import type { RouterOutputs } from '@duke-hq/svc-api/admin';

export type UploadedAgreement = { filename: string; drn: string };

export type PlacementUnit = {
  unitOfCompetencyId: string;
  code: string;
  title: string;
};

export type PlacementDetailsState = {
  startedAt: string;
  agreement: UploadedAgreement | null;
  notes: string;
};

export function isPlacementDetailsValid(details: PlacementDetailsState): boolean {
  return details.startedAt !== '';
}

export const emptyPlacementDetails: PlacementDetailsState = {
  startedAt: '',
  agreement: null,
  notes: '',
};

export type PlacementContract = Pick<
  NonNullable<RouterOutputs['workPlacements']['placements']['journeyByEnrolment']['contract']>,
  'id' | 'documentUrl' | 'employer' | 'employerContact'
>;
